import { CommonModule } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { TranslocoDirective } from "@jsverse/transloco";
import { ButtonModule } from "primeng/button";
import { OrganizationDetails } from "../../../../domain/organization";

@Component({
  selector: "app-tos-warning-banner",
  standalone: true,
  imports: [CommonModule, TranslocoDirective, ButtonModule],
  template: `
    <div *transloco="let t">
      @if (showWarning()) {
        <div class="fixed bottom-10 left-1/2 transform -translate-x-1/2 z-[1000] w-full max-w-2xl px-4 ">
          <div
            class="flex flex-row bg-yellow-50 dark:bg-yellow-950 border border-yellow-200 dark:border-yellow-800 text-yellow-600 dark:text-yellow-400 rounded-lg p-2 gap-4 shadow-lg"
          >
            <div class="flex items-center justify-center">
              <i class="pi pi-exclamation-triangle text-lg"></i>
            </div>
            <div class="flex flex-col gap-1">
              <span class="font-semibold">{{ t("app.tos.warningBanner.title") }}</span>
              <span>{{ t("app.tos.warningBanner.message") }}</span>
            </div>
            <div class="flex items-center justify-center">
              <p-button
                icon="pi pi-times"
                [text]="true"
                [rounded]="true"
                styleClass="text-yellow-600"
                (onClick)="closeWarning()"
              />
            </div>
          </div>
        </div>
      }
    </div>
  `,
})
export class TosWarningBannerComponent implements OnInit {
  @Input() organization: OrganizationDetails | null = null;
  @Input() isInternalUser: boolean | null = false;

  private storageKey = "tosWarningDismissed";
  private dismissed = false;

  ngOnInit() {
    const dismissedOrgs = this.getDismissedOrganizations();
    if (this.organization && dismissedOrgs.includes(this.organization.id)) {
      this.dismissed = true;
    }
  }

  showWarning(): boolean {
    // Check if organization has tosAcceptedAt
    return this.organization?.tosAcceptedAt === null && this.isInternalUser === true && !this.dismissed;
  }

  closeWarning(): void {
    this.dismissed = true;
    if (this.organization) {
      this.saveDismissedOrganization(this.organization.id);
    }
  }

  private getDismissedOrganizations(): number[] {
    const stored = sessionStorage.getItem(this.storageKey);
    return stored ? JSON.parse(stored) : [];
  }

  private saveDismissedOrganization(orgId: number): void {
    const dismissed = this.getDismissedOrganizations();
    if (!dismissed.includes(orgId)) {
      dismissed.push(orgId);
      sessionStorage.setItem(this.storageKey, JSON.stringify(dismissed));
    }
  }
}
